@if (isLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
} @else {
  <div class="grouping-container">
    <bsh-booking-stats class="stats"></bsh-booking-stats>
    <div class="options-container">
      <rds-switch [(ngModel)]="showLegend">Show legend</rds-switch>
      <rds-switch [(ngModel)]="showValues">Show values</rds-switch>
    </div>
    <div class="charts-container">
      <div class="chart-container">
        <bsh-grouped-bar-chart
          [currentConfig]="{
            showLegend: showLegend,
            hideZeroValues: true,
            showSubgroupValues: showValues,
            title: 'Average bookings per month per room type',
          }"
          [currentChartData]="countPerMonthRT()"></bsh-grouped-bar-chart>
      </div>
      <div class="chart-container">
        <bsh-grouped-bar-chart
          [currentChartData]="averagePerWeekday()"
          [currentConfig]="{
            showSubgroupLabels: true,
            showSubgroupValues: showValues,
            showLegend: false,
            title: 'Total average bookings per weekday',
          }"></bsh-grouped-bar-chart>
      </div>
    </div>
    <div class="charts-container">
      <div class="chart-container">
        <bsh-grouped-bar-chart
          [currentConfig]="{
            showSubgroupValues: showValues,
            hideZeroValues: true,
            showLegend: false,
            title: 'Average number of people per room type',
            legendWidth: 200,
          }"
          [currentChartData]="
            averagePeoplePerRoomType()
          "></bsh-grouped-bar-chart>
      </div>
      <div class="chart-container">
        <bsh-pie-chart
          [data]="countPerStatus()"
          [config]="{
            title: 'Bookings amount per status',
            showLegend: false,
          }"></bsh-pie-chart>
      </div>
    </div>
    <div class="charts-container">
      <bsh-bookings-table
        [bookingsData]="bookingsData()"
        [paginationState]="tablePaginationState()"
        (pageChanged)="onPageChange($event)"
        (csvExportRequested)="exportToCSV()"
        class="stats"></bsh-bookings-table>
    </div>
  </div>
}
